import React from 'react';
import { useLanguage } from '../LanguageContext';

const Services = () => {
  const { t } = useLanguage();

  const services = [
     {
      title: t('productDevelopment'),
      description: t('productDevelopmentDesc')
    },
    {
      title: t('webDevelopment'),
      description: t('webDevDesc')
    },
    {
      title: t('mobileApps'),
      description: t('mobileAppsDesc')
    },
    {
      title: t('digitalMarketing'),
      description: t('digitalMarketingDesc')
    }
  ];

  return (
    <section id="services">
      <div className="section-content">
        <h2>{t('ourServices')}</h2>
        <p>{t('servicesDescription')}</p>
        <div className="card-container">
          {services.map((service, index) => (
            <div key={index} className="card">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
